import { Box, Typography } from "@mui/material";
import React from "react";
import moment from "moment-timezone";
import List from "../../../components/List";
import { EmptyView } from "../../../components/OList";
import { notificationAdd } from "../../../actions/notification";
import { errorFetchMessage, MODULE } from "../../../helpers/messages";
import { useAppDispatch } from "../../../store/hooks";
import { SurveyData } from "./SurveyCreateEditForm";
import { getSurveyForms } from "../../../api/surveyForm";

interface Props {
  clientId: number;
  onRowClick: (value: SurveyData) => void;
}
const SurveyFormList = ({ clientId, onRowClick }: Props): JSX.Element => {
  const dispatch = useAppDispatch();
  const [data, setData] = React.useState<SurveyData[]>([]);

  React.useEffect(() => {
    (async () => {
      try {
        const response = await getSurveyForms(clientId);
        setData(response);
      } catch (e) {
        dispatch(
          notificationAdd({
            id: new Date().getTime(),
            message: errorFetchMessage(MODULE.SURVERY_FORM),
            variant: "error",
            autoTimeout: true
          })
        );
      }
    })();
  }, [clientId]);

  return (
    <List<SurveyData>
      automation="surveyList"
      withoutSearch
      hideCreateButton
      rowHeight={40}
      data={data}
      adjustHeightToContents
      onRowClick={(row) => {
        onRowClick(row);
      }}
      columns={[
        {
          key: "created_at",
          label: "Date",
          // eslint-disable-next-line camelcase
          formatter: ({ created_at }) => (
            <Typography>{moment(created_at).format("DD-MM-YYYY")}</Typography>
          )
        }
      ]}
    >
      <EmptyView>
        <Box fontSize="0.7rem" marginTop="16px" display="flex" justifyContent="center">
          No survey taken by the client yet...
        </Box>
      </EmptyView>
    </List>
  );
};

export default SurveyFormList;
